'use client';

import '@findy/kuja/dist/css/index.css';
import '@findy/kuja/dist/css/index-v2.css';

import { Global } from '@emotion/react';

/**
 * プロダクト向け基本スタイル
 *
 * LoggedInLayoutとNoLoginLayoutで主に使用されています。
 * (Findyのコア機能で利用されていることから、便宜上プロダクト向けと呼びます)
 */

const baseStyle = `
  html,
  body {
    height: 100%;
  }

  html {
    position: relative;
    min-height: 100%;
    font-size: 62.5%;
  }

  body {
    min-width: 320px;
    padding: 0;
    margin: 0;
    overflow-x: hidden;
    font-size: 1.2rem;
    line-height: 1.6;
    color: var(--fds-color-text-primary);
    text-align: left;
    background: #ffffff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  p {
    padding: 0;
    margin: 0;
  }

  /* Modalが表示されている間の背面のスクロールを防ぐ */
  .ReactModal__Body--open {
    overflow: hidden;
  }
`;

/**
 * プロダクト向けの基本スタイルをグローバルスタイルとして適用する。
 * normalize.css等の初期化スタイルは含まれていません。_app.tsxで適用されている GlobalStyle との併用を前提としています。
 */
export const ProductGlobalStyle = () => <Global styles={baseStyle} />;
